import TranslationError from '../Translations/TranslationError';
import Translations from '../Translations';
import React, {
    useState,
    useEffect,
} from 'react';
import {
    Modal,
    Button, 
} from 'semantic-ui-react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {
    toast,
} from 'react-toastify';

import {
    handleUpdateCoverageOption,
    handleGetCoverages,
} from '../../actions';
import {queryCoveragesByMember} from '../../api/selectiongql';
import {
    ABBTH_ONE_DEPENDENT_OPTION_KEY,
    applySingleDependentCoverageSelection,
    isNoCoverage,
} from '../../utils/abbth';
import ProductOption from '../product/option';
import ModalError from './errornoti';
import {formatAmountWithCurrency} from '../../utils/currency';
import {generateTranslationKey} from '../../utils/convert.util';

const LIMIT_DEP_OTPIONS = {
    PRODUCTS: [
        "691fe9efed0210d611d3c3fb", // LOAD - Natwest SG - Group Term Life FY25
        "691fea36ed0210d611d3c421", // LOAD - Natwest SG - Group Personal Accident FY25
        "691feaaced0210d611d3c447", // LOAD - Natwest SG - Group Critical Illness FY25  
        "691ffec3ed0210d611d3c87d", // LOAD - Natwest SG - Group Critical Illness FY26
        "691ffd36ed0210d611d3c786", // LOAD - Natwest SG - Group Personal Accident FY26
        "691ffca4ed0210d611d3c747", // LOAD - Natwest SG - Group Term Life FY26

        "693287d7e9731800a34b4636", // PROD - Natwest SG - Group Term Life FY26,
        "69328848e9731800a34b4637", // PROD - Natwest SG - Group Personal Accident FY26
        "693288a3e9731800a34b4638" // PROD - Natwest SG - Group Critical Illness FY26
    ],
    EXTERNAL_AFFECTED: {
        "691fe9efed0210d611d3c3fb": "691feaaced0210d611d3c447", // LOAD - Natwest SG - Group Term Life FY25 => Group Critical Illness FY25
        "691ffca4ed0210d611d3c747": "691ffec3ed0210d611d3c87d", // LOAD - Natwest SG - Group Term Life FY26 => Group Critical Illness FY26
        "693287d7e9731800a34b4636": "693288a3e9731800a34b4638", // PROD - Natwest SG - Group Term Life FY26 => Group Critical Illness FY26
    },
    EXTERNAL_LINKED: {
        "691feaaced0210d611d3c447": "691fe9efed0210d611d3c3fb", // LOAD - Natwest SG - Group Critical Illness FY25 => Group Term Life FY25 
        "691ffec3ed0210d611d3c87d": "691ffca4ed0210d611d3c747", // LOAD - Natwest SG - Group Critical Illness FY26 => Group Term Life FY26
        "693288a3e9731800a34b4638": "693287d7e9731800a34b4636", // PROD - Natwest SG - Group Critical Illness FY26 => Group Term Life FY26
    }
};
const ModalSelectProductOption = (props) => {

    const {
        handleUpdateCoverageOption,
        handleGetCoverages,
        productName,
        productType,
        getAllCoverages, // Mapping: member >> product >> coverave
        coverages,
        coverage,
        family,
        member,
        currencyMinorUnit,
        currency,
        productKey,
        token,
    } = props;
    const {
        id,
        options,
        // product,
        selectOption,
    } = coverage;

    const [open, setOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [selectedOption, setSelectedOption] = useState(selectOption.id);
    const [loading, setLoading] = useState(false);

    // console.log('load selectproductoption->', productName);

    useEffect(() => {
        setSelectedOption(selectOption.id);
        // console.log('-> useEffect', 'Set Select Option', productName, selectOption);
    }, [selectOption, productName,]);

    const getCoreMember = () => {
        return family?.coreMember;
    }
    const handleUpdateSelectedOption = (selectedOptionId) => {
        setSelectedOption(selectedOptionId);
    };
    const getOptions = () => {
        const ACTIVE_STATUS = 1;
        let options = coverage.options;
        if (!options) return [];
        let newData = [];
        let sumAssuredList = [];
        let cMember = getCoreMember();
        let cMemberId = cMember?.id || "";
        // let data = options.filter(item => item.status == ACTIVE_STATUS);
        let data = options;
        // let selectedOpt = data.find(item => item.id == selectedOption);
        // console.log("_coverage", _coverage)
        data.forEach(item => {
            if (!item.sumAssured) {
                newData.push(item);
            } else if (!sumAssuredList.includes(item.sumAssured)) {
                newData.push(item);
                sumAssuredList.push(item.sumAssured);
            } else if (item.isDefault) { // core option
              // override 
              // console.log("isDefault", item)
                newData = newData.filter(o => o.sumAssured != item.sumAssured);
                newData.push(item);
            }
            // console.log(item)
        });
        // Updated by falcon at 03/12/2025
        // Limit dependent options based on core member coverage (like self-link product)
        const isProductLimited = LIMIT_DEP_OTPIONS.PRODUCTS.includes(coverage?.product?.id);
        if (isProductLimited && member != cMemberId) {
          let coverageMap = _.clone(coverages) || {};
          let cMemberCoverage = coverageMap[cMemberId];
          let cMemberOption = cMemberCoverage?.options?.find(o => o.id == cMemberCoverage?.selectOption?.id) || null;
          let cMemberSumAssured = cMemberOption?.sumAssured || 0;
          if (cMemberSumAssured) {
            newData = newData.filter(o => o.sumAssured <= cMemberSumAssured);
          }
        }
        let isExistSelectOpt = newData.find(item => item.id == selectedOption);
        let newSelectOpt;
        if (!isExistSelectOpt) {
            // select default option
            newSelectOpt = newData.find(item => item.isDefault == true)?.id;
            if (!newSelectOpt) {
                // select $0
                newSelectOpt = newData.find(item => item.price == 0)?.id;
            }
            if (!newSelectOpt) {
                // select first opt
                newSelectOpt = newData[0]?.id;
            }
            if (newSelectOpt && newSelectOpt != selectedOption) {
              handleUpdateSelectedOption(newSelectOpt);
            }
        }
        return newData;
    }
    const renderOptions = () => {
        return _.map(getOptions(), (opt) => {
            return (
                <ProductOption
                    key={opt.id}
                    option={opt}
                    selectedOption={selectedOption}
                    handleUpdateSelectedOption={handleUpdateSelectedOption}
                    productType={productType}
                    currencyMinorUnit={currencyMinorUnit}
                    currency={currency}
                    productKey={productKey}
                />
            )
        });
    };
    /**
     * @function updateOption
     * @updatedBy falcon
     * @updatedAt 04/12/2025 - _skipUpdateData
     * @params _skipUpdateData => ignore renew data -> only use for the hardcode products (natwest sg)
     */
    const updateOption = (_coverageId, _optionId, _member, _skipUpdateData = false) => {
        return new Promise((resolve, reject) => {
            handleUpdateCoverageOption(
                { 
                    coverageId: _coverageId, 
                    optionId: _optionId, 
                    member: _member, 
                    skipUpdateData: _skipUpdateData 
                },
                reject,
                resolve
            );
        });
    };

    const getResetDepsData = () => {
        let _data = [];
        // TODO: implement reset here
        // Reset options for all dependents
        let _coverageMap = _.clone(coverages) || {};
        // Remove the core member from the list — only process dependents
        delete _coverageMap[member];
        for (let _memberId in _coverageMap) {
            let _coverage = _coverageMap[_memberId];
            if (!_coverage) continue;

            let _options = _coverage.options || [];

            // 1. Try to find the default option
            let _baseOptionId = _options.find(item => item.isDefault == true)?.id;

            // 2. If no default option, pick the option priced at $0
            if (!_baseOptionId) {
              _baseOptionId = _options.find(item => item.price == 0)?.id;
            }

            // 3. If still none, select the cheapest option
            if (!_baseOptionId) {
              _options = _.orderBy(_options, "price", ['asc']);
              _baseOptionId = _options[0]?.id;
            }
            let _selectedOptionId = _coverage?.selectOption?.id;
            
            if (_baseOptionId && _baseOptionId != _selectedOptionId) {
                _data.push({
                    coverageId: _coverage.id, 
                    optionId: _baseOptionId, 
                    member: _memberId 
                })
                // await updateOption(_coverage.id, _baseOptionId, _memberId, _skipUpdateData);
            }            
        }
        return _data;
    }

    const handleResetDepsOption = async (resetDepsData) => {
        let _skipUpdateData = true;
        for (let i = 0; i < resetDepsData.length; i++) {

            if (i == resetDepsData.length - 1) {
                _skipUpdateData = false;
            }
            await updateOption(resetDepsData[i].coverageId, resetDepsData[i].optionId, resetDepsData[i].member, _skipUpdateData);          
        }

    };
    const getAbbthOneDependentSelection = () => {
        if (productKey !== 'abbth-ghs') return {apply: false};
        const coreMemberId = family?.coreMember?.id;
        const selectedCoverageOption = options?.find(option => option.id === selectedOption);
        const coreCoverage = coverages[coreMemberId];
        const currentCoreOption = coreCoverage?.options?.find(option => option.id === coreCoverage.selectOption?.id);
        const selectingCoreOption = member === coreMemberId &&
            selectedCoverageOption?.optionKey === ABBTH_ONE_DEPENDENT_OPTION_KEY;
        const selectingDependent = member !== coreMemberId &&
            currentCoreOption?.optionKey === ABBTH_ONE_DEPENDENT_OPTION_KEY;

        if (selectingCoreOption && !family.dependents.length) {
            return {error: <Translations text="selection.dependent_required" backup={"This option requires a dependent."} />};
        }
        const coveredDependents = family.dependents.filter(dependent => {
            const item = coverages[dependent.id];
            const current = item?.options?.find(option => option.id === item.selectOption?.id);
            return current && !isNoCoverage(current);
        });
        if (selectingDependent && isNoCoverage(selectedCoverageOption) && coveredDependents.length <= 1) {
            return {error: <Translations text="selection.select_another_dependent_first" backup={"Select another dependent before removing this coverage."} />};
        }
        return {
            apply: selectingCoreOption || (selectingDependent && !isNoCoverage(selectedCoverageOption)),
            selectedDependentId: selectingDependent ? member : (coveredDependents[0] || family.dependents[0])?.id,
        };
    };
    const handleSubmitOption = async () => {
        let cMember = getCoreMember();
        let cMemberId = cMember?.id || "";
        let isProductLimited = LIMIT_DEP_OTPIONS.PRODUCTS.includes(coverage?.product?.id);
        let isCoreMember = cMemberId == member;
        let resetDepsData = [];
        let skipUpdateData = false;
        const abbthSelection = getAbbthOneDependentSelection();
        if (abbthSelection.error) {
            setErrorMessage(abbthSelection.error);
            setIsError(true);
            return;
        }

        if (isProductLimited && isCoreMember) {
            resetDepsData = getResetDepsData();
            if (resetDepsData.length > 0) {
                skipUpdateData = true;
            }
        }

        /**
         * @updatedBy falcon
         * @updatedAt 06/12/2025
         * @dev Validation for externally linked products (GCI linked with GTL)
         * 
         * Business Logic:
         * - GCI sum assured cannot exceed GTL sum assured.
         * - GTL sum assured cannot be lower than the selected GCI sum assured.
         * 
         * Notes:
         * - Only one condition block will run per execution because a product
         *   cannot be both "linked" and "affected" at the same time.
         * - Wrapped in try/catch to ensure UI stability even if underlying data is incomplete.
         */
        try {
            let _product = coverage?.product?.id;
            let _member = member;
            let _isCoreMember = isCoreMember;
            // =====================================================================
            // CASE 1: GCI is selected → it must NOT exceed its linked GTL sum assured
            // =====================================================================
            if (LIMIT_DEP_OTPIONS.EXTERNAL_LINKED[_product]) {
                // Retrieve current coverages for the member
                let _coverages = getAllCoverages();

                // Linked GTL product ID for this GCI
                let _originalProdId = LIMIT_DEP_OTPIONS.EXTERNAL_LINKED[_product];

                // GTL data
                let _externalCoverage = _coverages[_member][_originalProdId];
                let _externalCoverageOptions = _externalCoverage?.options || [];

                // GTL option currently selected by the user
                let _externalSelected = _externalCoverageOptions.find(o => o.id == _externalCoverage?.selectOption?.id);
                let _externalSelectedSumAssured = _externalSelected?.sumAssured || 0;

                // GCI being selected
                let _coverage = _coverages[_member][_product];
                let _coverageOptions = _coverage?.options || [];

                // New selected GCI option
                let _newSelected = _coverageOptions.find(o => o.id == selectedOption);
                let _newSelectedSumAssured = _newSelected?.sumAssured || 0;

                // Validate: GCI must not exceed GTL
                if (_newSelectedSumAssured > _externalSelectedSumAssured) {
                    setErrorMessage(<Translations text="selection.gci_sum_assured_limit" backup={"Please select a GCI sum assured that is less than or equal to {{amount}}."} data={{ amount: formatAmountWithCurrency(_externalSelectedSumAssured, currency) }} />);
                    setIsError(true);
                    return;
                }
            }

            // =====================================================================
            // CASE 2: GTL is selected → it must NOT be lower than the selected GCI
            // =====================================================================
            // console.log("LIMIT_DEP_OTPIONS.EXTERNAL_AFFECTED[_product]", LIMIT_DEP_OTPIONS.EXTERNAL_AFFECTED[_product])
            if (LIMIT_DEP_OTPIONS.EXTERNAL_AFFECTED[_product]) {
                // Retrieve coverages
                let _coverages = getAllCoverages();

                // GCI linked to this GTL
                let _linkedProdId = LIMIT_DEP_OTPIONS.EXTERNAL_AFFECTED[_product];

                // validate for dependents
                if (_isCoreMember) {
                    for (let _memberId in _coverages) {
                        // skip core member, only handle dependents
                        if (_memberId == _member) continue;
                        // GCI data
                        let _linkedCoverage = _coverages[_memberId][_linkedProdId];
                        let _linkedCoverageOptions = _linkedCoverage?.options || [];

                        // Currently selected GCI option
                        let _linkedSelected = _linkedCoverageOptions.find(o => o.id == _linkedCoverage?.selectOption?.id);
                        let _linkedSelectedSumAssured = _linkedSelected?.sumAssured || 0;
                        if (_linkedSelectedSumAssured > 0) {
                            setErrorMessage(<Translations text="selection.remove_dependent_critical_illness_first" backup={"To change your Term Life coverage, you will need to review your Critical Illness coverage to remove all dependant coverages."} />);
                            setIsError(true);  
                            return;
                        }
                    }
                }

                // GCI data
                let _linkedCoverage = _coverages[_member][_linkedProdId];
                let _linkedCoverageOptions = _linkedCoverage?.options || [];

                // Currently selected GCI option
                let _linkedSelected = _linkedCoverageOptions.find(o => o.id == _linkedCoverage?.selectOption?.id);
                let _linkedSelectedSumAssured = _linkedSelected?.sumAssured || 0;

                // GTL being selected
                let _coverage = _coverages[_member][_product];
                let _coverageOptions = _coverage?.options || [];

                // New selected GTL option
                let _newSelected = _coverageOptions.find(o => o.id == selectedOption);
                let _newSelectedSumAssured = _newSelected?.sumAssured || 0;

                // Validate: GTL must not fall below GCI
                if (_newSelectedSumAssured < _linkedSelectedSumAssured) {
                    setErrorMessage(<Translations text="selection.gtl_sum_assured_minimum" backup={"Please select a GTL sum assured that is greater than or equal to {{amount}}."} data={{ amount: formatAmountWithCurrency(_linkedSelectedSumAssured, currency) }} />);
                    setIsError(true);  
                    return;
                }
            }

        } catch (e) {
            // Safety net for unexpected data structure or missing values
            console.error("EXTERNAL_LINK_VALIDATE_ERROR", e);
        }

        setLoading(true);
        try {
            await updateOption(id, selectedOption, member, skipUpdateData || abbthSelection.apply);
            
            if (isProductLimited && isCoreMember) {
                await handleResetDepsOption(resetDepsData);
            }
            if (abbthSelection.apply) {
                const updateCount = await applySingleDependentCoverageSelection({
                    dependentIds: family.dependents.map(dependent => dependent.id),
                    productId: coverage.product?.id,
                    selectedDependentId: abbthSelection.selectedDependentId,
                    loadCoverage: async (memberId, productId) => {
                        const result = await queryCoveragesByMember({member: memberId, token});
                        if (result instanceof Error) throw result;
                        return result.find(item => item.product?.id === productId);
                    },
                    updateCoverage: (update, skipReload) =>
                        updateOption(update.coverageId, update.optionId, update.member, skipReload),
                });
                if (updateCount === 0) await handleGetCoverages({});
            }
            setLoading(false);
            setOpen(false);
            toast.success(<Translations text="selection.option_updated_successfully" backup={"Option was updated successfully"} />);
        } catch(e) {
            setLoading(false);
            toast.error(<TranslationError error={e} backup="Your option could not be updated. Please try again." />);
            await handleGetCoverages({});
        } 
    };

    return (
        <>
            <Modal
                className="selection-option-modal"
                open={open}
                dimmer="inverted"
                trigger={(
                    <Button 
                        className="selection-option-trigger"
                        fluid
                        content={<span className="selection-option-trigger-text">{productName}</span>}
                        disabled={props.disabled}
                        // size="tiny" 
                        labelPosition="right"
                        icon="edit"
                        onClick={() => setOpen(true)}
                        style={{marginTop: 10}}
                    />
                )}
            >
                <Modal.Header>
                    {props.insuranceProductName ? (
                        <Translations
                            text={`insurance_product.${generateTranslationKey(props.insuranceProductName)}`}
                            backup={props.insuranceProductName}
                            render={translatedProductName => (
                                <Translations textKey="selection.select_option_title" backup="Change Plan Option" data={{ name: translatedProductName }} components={[<React.Fragment />, <strong />]} />
                            )}
                        />
                    ) : (
                        <Translations textKey="selection.select_option_title" backup="Change Plan Option" data={{ name: productName }} components={[<React.Fragment />, <strong />]} />
                    )}
                </Modal.Header>
                <Modal.Content>
                    {renderOptions()}
                </Modal.Content>
                <Modal.Actions>
                    <Button 
                        secondary
                        disabled={loading}
                        onClick={() => {
                            setSelectedOption(selectOption.id)
                            setOpen(false);
                        }}
                    ><Translations text="common.cancel" backup={"Cancel"} /></Button>
                    <Button
                        loading={loading}
                        content={<Translations text="common.save" backup={"Save"} />}
                        primary
                        labelPosition="right"
                        icon="checkmark"
                        onClick={handleSubmitOption}
                    />
                </Modal.Actions>
            </Modal>
            <ModalError 
                desc={errorMessage}
                open={isError}
                onSetOpen={setIsError}
            />
        </>
    );
};

export default connect(state => ({token: state.config.token}), {
    handleUpdateCoverageOption,
    handleGetCoverages,
})(ModalSelectProductOption);
